import { render } from "./GalleryFooter.vue?vue&type=template&id=36374d00"
import script from "./GalleryFooter.vue?vue&type=script&lang=js"
export * from "./GalleryFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__